import { restService, RestService } from 'app/api/common';

class UserInfoService {
    private static readonly BASE_PATH: string = '/userinfo';

    private readonly restService: RestService;

    public constructor() {
        this.restService = restService;
    }

    public readonly getUserInfo = (): Promise<OrderTrackerBackend.UserInfo> =>
        this.restService.get<OrderTrackerBackend.UserInfo>(UserInfoService.BASE_PATH);
}

const userInfoService = new UserInfoService();

export { userInfoService, UserInfoService };
